import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { COUNTRY_OPTIONS } from "../../constants/countries";
import { useTranslation } from "react-i18next";

interface AddressFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function AddressFields({
  profile,
  setProfile,
  readOnly,
  loading
}: AddressFieldsProps) {
  const { t } = useTranslation("talent");

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.address.fields.address_1.label")}
        </label>
        <Input
          id="address_1"
          disabled={readOnly}
          loading={loading}
          value={profile.address_1}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, address_1: val }));
          }}
          placeholder={t("forms.sections.address.fields.address_1.placeholder")}
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.address.fields.address_2.label")}
        </label>
        <Input
          id="address_2"
          value={profile.address_2}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, address_2: val }));
          }}
          placeholder={t("forms.sections.address.fields.address_2.placeholder")}
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.address.fields.postal_code.label")}
        </label>
        <Input
          id="postal_code"
          value={profile.postal_code}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, postal_code: val }));
          }}
          placeholder={t(
            "forms.sections.address.fields.postal_code.placeholder"
          )}
          disabled={readOnly}
          loading={loading}
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.address.fields.city.label")}
        </label>
        <Input
          id="city"
          value={profile.city}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, city: val }));
          }}
          placeholder={t("forms.sections.address.fields.city.placeholder")}
          disabled={readOnly}
          loading={loading}
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.address.fields.state.label")}
        </label>
        <Input
          id="state"
          disabled={readOnly}
          loading={loading}
          value={profile.state}
          onChange={(e) => {
            const val = e.target.value || "";
            setProfile((prev: any) => ({ ...prev, state: val }));
          }}
          placeholder={t("forms.sections.address.fields.state.placeholder")}
        />
      </div>
      <div className="space-y-1">
        <label className="text-sm font-medium">
          {t("forms.sections.address.fields.country.label")}
        </label>
        <Select
          disabled={readOnly}
          value={profile.country}
          onValueChange={(value) =>
            setProfile((prev: any) => ({ ...prev, country: value }))
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue
              placeholder={t(
                "forms.sections.address.fields.country.placeholder"
              )}
            />
          </SelectTrigger>
          <SelectContent>
            {COUNTRY_OPTIONS.map((country) => (
              <SelectItem key={country.value} value={country.value}>
                {country.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
